import script from "./ConfCancelPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfCancelPage2.vue?vue&type=script&setup=true&lang=js"

import "./ConfCancelPage2.vue?vue&type=style&index=0&id=495d59c6&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495d59c6"]])

export default __exports__